"use client";

import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useProductTileClickProps } from "../../ProductTileClickProvider/ProductTileClickContext";

export const ProductLinkForSDUIEvaluateTile = ({
  productToken,
  children,
}: {
  productToken: string;
  children: ReactNode;
}) => {
  const { productLinkProps, onProductClick } = useProductTileClickProps();

  return (
    <ProductLink
      onClick={onProductClick}
      data-test-id={`product-tile-link-${productToken}`}
      to={productLinkProps?.productUrl ?? ""}
    >
      {children}
    </ProductLink>
  );
};

const ProductLink = styled(Link)`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;
